import { create } from 'zustand';

// Cross-component UI state: the top bar opens panels that live elsewhere in the tree.
export const useUiStore = create((set) => ({
  askAiOpen: false,
  phoneOpen: false,
  searchOpen: false,
  phone: { status: '', live: false, label: '', seconds: 0, hasError: false },

  setAskAiOpen: (askAiOpen) => set({ askAiOpen }),
  setPhoneOpen: (phoneOpen) => set({ phoneOpen }),
  togglePhone: () => set((s) => ({ phoneOpen: !s.phoneOpen })),
  setSearchOpen: (searchOpen) => set({ searchOpen }),
  setPhoneState: (phone) => set((s) => ({ phone: { ...s.phone, ...phone } })),
}));
